// extracted by mini-css-extract-plugin
export var text = "_68-0";